module.exports = __webpack_public_path__ + "img/mxn.60ec0887.png";